export default {
  title: 'Paramètres du profil',
  subtitle: 'Votre adresse, votre langue, votre mot de passe et la sécurité de connexion',
  email: {
    title: 'Adresse e-mail',
    change: 'Modifier',
    dialogTitle: 'Changer votre adresse e-mail',
    newEmail: 'Nouvelle adresse e-mail',
    submit: 'Envoyer la confirmation',
    sent: "Un code et un lien sont en route vers {email}. Saisissez le code ici, ou ouvrez le lien : rien ne change tant que vous ne l'avez pas fait.",
    code: 'Code de confirmation',
    confirm: 'Confirmer',
    changed: 'Votre adresse e-mail a changé.',
    invalidAddress: "Cette adresse ne peut pas être utilisée : vérifiez-la, et qu'elle n'est pas déjà la vôtre.",
    invalidCode: "Ce code n'est plus valable. Redemandez le changement.",
    cancel: 'Annuler',
    close: 'Fermer',
  },
  language: {
    title: 'Langue',
    select: 'Sélectionner la langue',
    saved: 'Langue enregistrée',
  },
  password: {
    title: 'Mot de passe',
    change: 'Changer le mot de passe',
    new: 'Nouveau mot de passe',
    confirm: 'Confirmer le nouveau mot de passe',
    update: 'Mettre à jour le mot de passe',
    cancel: 'Annuler',
    changed: 'Votre mot de passe a changé. Vos autres sessions ont été déconnectées.',
    tooShort: 'Au moins {min} caractères',
    tooLong: 'Au plus {max} caractères',
    mismatch: 'Les deux mots de passe diffèrent',
    invalid: 'Ce mot de passe ne peut pas être utilisé.',
    closed: "La connexion par mot de passe n'est pas disponible sur cette plateforme.",
  },
  twoFactor: {
    title: 'Vérification en deux étapes',
    off: 'Désactivée. Activez-la pour saisir un code de votre téléphone à chaque connexion.',
    turnOn: 'Activer',
    turnOff: 'Désactiver',
    authenticator: "Application d'authentification",
    added: 'Ajoutée le {date}',
    lastUsed: 'utilisée le {date}',
    neverUsed: 'pas encore utilisée',
    recoveryRemaining: '{count} code de secours restant | {count} codes de secours restants',
    noRecovery:
      "Il ne vous reste aucun code de secours : sans eux, perdre votre téléphone vous bloque l'accès. Générez-en de nouveaux.",
    regenerate: 'Nouveaux codes de secours',
    enrolTitle: 'Activer la vérification en deux étapes',
    recoveryTitle: 'Vos codes de secours',
    regenerateTitle: 'Nouveaux codes de secours',
    regenerateExplain:
      "Saisissez un code de votre application, ou l'un de vos codes de secours. Vos codes de secours actuels cesseront de fonctionner.",
    removeTitle: 'Désactiver la vérification en deux étapes',
    removeExplain:
      "Saisissez un code de votre application, ou l'un de vos codes de secours. Vos codes de secours disparaissent avec elle.",
    code: 'Code',
    submitRegenerate: 'Générer de nouveaux codes',
    submitRemove: 'Désactiver',
    cancel: 'Annuler',
    removed: 'La vérification en deux étapes est désactivée.',
    invalidCode: "Ce code n'a pas fonctionné. Réessayez.",
    required:
      "La vérification en deux étapes est exigée sur cette plateforme ou par l'une de vos organisations : elle ne peut pas être désactivée.",
    noFactor: "La vérification en deux étapes n'est pas activée pour ce compte.",
    unavailable: "La vérification en deux étapes n'est pas disponible sur cette plateforme.",
    loadError: 'Vos paramètres de vérification en deux étapes sont illisibles pour le moment.',
  },
  sessions: {
    title: 'Où vous êtes connecté',
    current: 'Cette session',
    unknownDevice: 'Appareil inconnu',
    signedIn: 'connecté le {date}',
    lastActive: 'Actif le {date}',
    revoke: 'Déconnecter',
    revokeOthers: 'Déconnecter partout ailleurs',
    revoked: 'Cette session est déconnectée.',
    othersRevoked: 'Toutes les autres sessions sont déconnectées.',
    loadError: 'Vos sessions sont illisibles pour le moment.',
  },
  danger: {
    title: 'Zone de danger',
    description: 'Actions irréversibles et destructrices',
    warning:
      "Supprimer votre compte vous déconnecte partout et vous retire de toutes vos organisations. C'est refusé tant que vous êtes le dernier membre à pouvoir administrer une organisation : supprimez-la d'abord, ou transférez-la à un autre membre.",
    organizationsTitle: 'Vous possédez {count} organisation | Vous possédez {count} organisations',
    deleteAccount: 'Supprimer mon compte',
    deleteOrganization: "Supprimer l'organisation",
  },
}
